import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { loadEnv } from "./config/env";
import { consumeThemeFromUrl } from "./utils/theme";
import { preloadFonts } from "./utils/fontPreload";
import { loadStripeAfterRender } from "./utils/stripePreload";
import { reloadOnStaleChunks } from "./utils/staleChunkReload";
import "./index.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

// A `?theme=` on the URL is WeHunt Web handing the member's light/dark choice
// back to us: adopt it (and drop it from the address bar) before anything
// renders or builds a link from the current URL.
consumeThemeFromUrl();

// Fonts download alongside the env, layout and content requests, so they are
// in before the first text renders instead of swapping in over it.
preloadFonts();

loadStripeAfterRender();

reloadOnStaleChunks();

// Load environment config before rendering
loadEnv().then(() => {
  createRoot(rootElement).render(
    <StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </StrictMode>
  );
});
